import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./components/sections/web_core/Navbar";
import Pricing from "./components/pages/Pricing";
import About from "./components/pages/About";
import Services from "./components/pages/Services";
import Courses from "./components/pages/Courses";
import Contact from "./components/pages/Contact";
import HomePage from "./components/pages/Home";
import LeadForm from "./components/pages/LeadForm";
import Layout from "./components/sections/web_core/layout";
import BlogDetail from "./components/sections/content_component/BlogDetail";
import InstructorSection from './components/sections/scholar_comp/InstructorSection';
import Scholarsec from "./components/sections/scholar_comp/scholarsec";
import ScholarDetails from "./components/pages/scholars";
import Blogs from "./components/pages/Blog";
import BlogExt from "./components/sections/content_component/Blogext";
import BlogCarousel from "./components/sections/content_component/BlogCaraousal";
import PrivacyPolicy from "./components/pages/privacyplicy";
import TermsOfUse from "./components/pages/termsofuse";
<div>


</div>
function AppWrapper() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Navbar />

      <div style={{ paddingTop: "0px" }}>
        <Routes>
          <Route element={<Layout />}></Route>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/lead-form" element={<LeadForm />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/scholar/:id/details" element={<ScholarDetails />} />
          <Route path="/" element={<InstructorSection />} />
          <Route path="/scholar/:id" element={<Scholarsec />} />
          <Route path="/scholar/:id/details" element={<ScholarDetails />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/" element={<BlogCarousel />} /> 
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/blog/:id/details" element={<BlogDetail />} /> 
          <Route path="/blog/:id/ext" element={<BlogExt />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />

        </Routes>

      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;